<template>
  <div>
    <el-cascader
      size="large"
      :options="options"
      v-model="selectedOptions"
      @change="handleChange"  class="lsj"  :style="address_with">
    </el-cascader>
    <slot name="lsj"></slot>
  </div>
</template>
<script>
import { regionData, CodeToText } from 'element-china-area-data'

export default {
  name: 'addressView',
  props: ['address_with', 'choice_address', 'address_data'],
  data () {
    return {
      options: regionData,
      selectedOptions: []
    }
  },

  watch: {
    'address_data': {
      immediate: true,
      handler: function handler(val) {
        this.selectedOptions = val
      }
    }
  },
  methods: {
    handleChange (value) {
      this.provinceName = CodeToText[value[0]]
      this.cityName = CodeToText[value[1]]
      this.countyName = CodeToText[value[2]]
      var json = {'birthplace': this.provinceName + '/' + this.cityName + '/' + this.countyName, 'birthplace_code': value}
      this.$emit('choice_address', JSON.stringify(json))
    }
  }
}
</script>
<style>
.lsj{float: left}
</style>



// WEBPACK FOOTER //
// src/components/mycenter_studyabroad/component/address_view.vue